export default __webpack_public_path__ + "static/escenario-virtual-fisher-price-4e10febd82275dd9892136d50e931a49.jpg";